/**
 * Lists the different types of snackbar messages. The suffixes of _ERROR and _SUCCESS are used to
 * denote the type of snackbar.
 */
const snackbarTypes = {
  REVIEW_SUBMISSION_ERROR: 'REVIEW_SUBMISSION_ERROR',
  REVIEW_SUBMISSION_SUCCESS: 'REVIEW_SUBMISSION_SUCCESS',
  SETTINGS_ERROR: 'SETTINGS_ERROR',
  SETTINGS_SUCCESS: 'SETTINGS_SUCCESS',
  SUBMISSION_ERROR: 'SUBMISSION_ERROR',
  SUBMISSION_SUCCESS: 'SUBMISSION_SUCCESS',
  VOTING_ERROR: 'VOTING_ERROR',
  VOTING_SUCCESS: 'VOTING_SUCCESS',
};

export default snackbarTypes;
